import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

//import images
import avatar1 from '../../assets/images/users/avatar-1.jpg'
import { createSelector } from 'reselect'

const ProfileDropdown = () => {
  const profiledropdownData = createSelector(
    (state: any) => state.Profile.user,
    (user) => user
  )
  const user = useSelector(profiledropdownData)

  const [userName, setUserName] = useState('Admin')

  useEffect(() => {
    const authUSer: any = sessionStorage.getItem('authUser')
    if (authUSer) {
      const obj: any = JSON.parse(authUSer)
      setUserName(
        process.env.REACT_APP_DEFAULTAUTH === 'fake'
          ? obj.username === undefined
            ? user?.fullName || user?.first_name
              ? user?.fullName || user?.first_name
              : obj.data?.fullName || obj.data?.first_name
            : 'Admin' || 'Admin'
          : process.env.REACT_APP_DEFAULTAUTH === 'firebase'
            ? obj.email && obj.email
            : 'Admin'
      )
    }
  }, [userName, user])

  return (
    <React.Fragment>
      <div className='ms-sm-3 header-item topbar-user'>
        <span className='d-flex align-items-center btn shadow-none' style={{ cursor: 'default' }}>
          <img className='rounded-circle header-profile-user' src={avatar1} alt='Header Avatar' />
          <span className='text-start ms-xl-2'>
            <span className='d-none d-xl-inline-block ms-1 fw-medium user-name-text'>
              {userName}
            </span>
          </span>
        </span>
      </div>
    </React.Fragment>
  )
}

export default ProfileDropdown
